import { render, staticRenderFns } from "./importdata-sp.vue?vue&type=template&id=67674666&scoped=true&"
import script from "./importdata-sp.vue?vue&type=script&lang=js&"
export * from "./importdata-sp.vue?vue&type=script&lang=js&"
import style0 from "./importdata-sp.vue?vue&type=style&index=0&id=67674666&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67674666",
  null
  
)

export default component.exports